// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"230":"component---src-pages-index-jsx","256":"component---src-pages-404-jsx","532":"styles","661":"component---src-pages-contact-jsx"}[chunkId] + "-" + {"230":"2de603fd96189815eeb6","256":"247ca78da59369b72684","532":"b2b19679afaab11bf0cb","661":"d1c3db32dacf415628c0"}[chunkId] + ".js";
};